import './dream-theme.css'; // shared --dg-* tokens; master in dream-home/theme
import './app.css';
import './lib/settings';   // applies the saved text-size on load
import { mount } from 'svelte';
import App from './App.svelte';
import DemoApp from './demo/DemoApp.svelte';

// /tracker is the physician tracking dashboard: key-gated (no Google sign-in),
// synthetic record, every lab/vital collated under its condition. (/demo on this
// host is the patient app itself, assembled into dist/demo at deploy time.)
// Everything else is the admin console.
const isDemo = /^\/(tracker|demo-tracker)(\/|$)/.test(location.pathname);
export default mount(isDemo ? DemoApp : App, { target: document.getElementById('app')! });
